export default __webpack_public_path__ + "static/media/strava-seeklogo.com.4b9e035a.svg";